import React from 'react'
import { Header, Columns } from '../../../../components/elements'
import { Subscribe } from 'unstated'
import AppContainer from '../../../context/AppContainer'
import * as Cookies from 'js-cookie'
import './header.css'
import OwnerBadge from '../ownerBadge'

const MotoProfileHeader = ({ bikeData, isMobile }) => {
  return (
    <Columns breakpoint={'mobile'} className="is-vcentered">
      <Columns.Column className="pt-0" size={10} className="header-column">
        {bikeData.bike_name && (
          <div className="is-size-7 mb-1 has-text-weight-bold">
            {bikeData.bike_nickname}
          </div>
        )}
        <Header
          size={isMobile ? 4 : 3}
          renderas="h1"
          className="has-black-dark-text has-text-weight-extra-bold bike-listing-main-header"
        >
          {bikeData.bike_year} {bikeData.bike_title}
        </Header>
        {bikeData.bike_overall_rating > 0 ? (
          <div className="bike-metadata">
            {bikeData.bike_overall_rating > 0 ? (
              <p className="bike-rating">
                <span>{bikeData.bike_overall_rating}</span>&nbsp;
                <i className="fa fa-star bike-profile-bike-rating"></i>&nbsp;
              </p>
            ) : null}
            {bikeData.bike_review_count > 0 ? (
              <p className="is-paragraph-text review-count">
                {bikeData.bike_review_count + ' Reviews '}
              </p>
            ) : null}
            &nbsp;
            {bikeData.trips_taken > 0 ? (
              <p className="is-paragraph-text">
                ({bikeData.trips_taken}
                {bikeData.trips_taken > 1 ? ' Total Trips' : ' Total Trip '})
              </p>
            ) : null}
          </div>
        ) : bikeData.bike_review_count > 0 ? (
          <div className="bike-metadata">
            {bikeData.bike_overall_rating > 0 ? (
              <p className="bike-rating">
                <span>{bikeData.bike_overall_rating}</span>&nbsp;
                <i className="fa fa-star bike-profile-bike-rating"></i>&nbsp;
              </p>
            ) : null}
            {bikeData.bike_review_count > 0 ? (
              <p className="is-paragraph-text">
                {bikeData.bike_review_count + ' Reviews '}
              </p>
            ) : null}
            &nbsp;
            {bikeData.trips_taken > 0 ? (
              <p className="is-paragraph-text">
                {bikeData.trips_taken}
                {bikeData.trips_taken > 1 ? ' Total Trips' : ' Total Trip '}
              </p>
            ) : null}
          </div>
        ) : bikeData.trips_taken > 0 ? (
          <div className="bike-metadata">
            {bikeData.bike_overall_rating > 0 ? (
              <p className="bike-rating">
                <span>{bikeData.bike_overall_rating}</span>&nbsp;
                <i className="fa fa-star bike-profile-bike-rating"></i>&nbsp;
              </p>
            ) : null}
            {bikeData.bike_review_count > 0 ? (
              <p className="is-paragraph-text">
                {bikeData.bike_review_count + ' Reviews '}
              </p>
            ) : null}
            &nbsp;
            {bikeData.trips_taken > 0 ? (
              <p className="is-paragraph-text">
                {bikeData.trips_taken}
                {bikeData.trips_taken > 1 ? ' Total Trips' : ' Total Trip '}
              </p>
            ) : null}
          </div>
        ) : null}
        {bikeData.bike_location.location_city && (
          <Header
            size={isMobile ? 6 : 5}
            renderas="div"
            className="mb-1 bike-profile-location"
          >
            {bikeData.bike_location.location_city},
            {' ' + bikeData.bike_location.location_region_abbr}
          </Header>
        )}
        <div className="tags are-normal mt-2">
          {bikeData.is_newly_listed && (
            <span className="black-tag tag is-rounded">
              <i className="fas fa-flag-checkered bolt-custom-icon"></i>Newly
              Listed
            </span>
          )}
          {bikeData.can_book_instantly && (
            <span className="black-tag tag is-rounded">
              <i className="fas fa-bolt bolt-custom-icon"></i>Book Instantly
            </span>
          )}
        </div>
        <Subscribe to={[AppContainer]}>
          {(auth) => {
            return (
              <>
                {auth.state.isAuth &&
                  Cookies.get('userID') === bikeData.bike_owner_id && (
                    <div>
                      <a
                        className="edit-link-from-bike-profile"
                        href={'/dashboard/garage/edit/' + bikeData.bike_uuid_id}
                      >
                        <i className="fal fa-pencil" /> Edit Listing
                      </a>
                    </div>
                  )}
              </>
            )
          }}
        </Subscribe>
      </Columns.Column>
      <Columns.Column
        mobile={{
          size: 2,
        }}
        tablet={{
          size: 2,
        }}
      >
        {bikeData.twenty_point_inspected && (
          <div className="inspection-tag-container-profile">
            <div className="inspection-tag-profile">
              <div className="inspection-tag-content-profile has-text-centered has-text-weight-semibold">
                <div className="inspection-tag-date-profile">
                  {bikeData.last_inspection_date_formatted}
                </div>
              </div>
            </div>
          </div>
        )}
      </Columns.Column>
    </Columns>
  )
}

export default MotoProfileHeader
